import React, { useMemo } from 'react';
import { fmt, monthText, num } from './helpers';
import { stdOutlineBtn, stdTableWrap, stdTh } from '../adminlayout/designStandard';

export default function MonthlyRevenueTable({ rows, loading, selectedMonth, onSelectMonth }) {
  const cumulative = useMemo(() => {
    const map = new Map();
    let running = 0;
    [...rows].reverse().forEach((row) => {
      running += num(row.net_profit);
      map.set(`${row.company_code}-${row.month}`, running);
    });
    return map;
  }, [rows]);

  return (
    <section style={cardStyle}>
      <div style={sectionHead}>
        <h3 style={sectionTitle}>월별 집계</h3>
        <button type="button" onClick={() => onSelectMonth('')} style={smallBtn}>전체 상세</button>
      </div>
      <div style={stdTableWrap}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th>월</Th>
              <Th right>예약</Th>
              <Th right>예약/변경/취소</Th>
              <Th right>상세정산</Th>
              <Th right>고객변화</Th>
              <Th right>원가변화</Th>
              <Th right>공급사환불</Th>
              <Th right>취소수수료</Th>
              <Th right>추가원가</Th>
              <Th right>기타</Th>
              <Th right>월수익</Th>
              <Th right>누적수익</Th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={12} style={emptyTd}>{loading ? '조회 중...' : '데이터가 없습니다.'}</td></tr>
            ) : rows.map((row, index) => {
              const month = monthText(row.month);
              const selected = selectedMonth === month;
              const last = index === rows.length - 1; // 마지막 행 밑줄 제거 (표준)
              return (
                <tr key={`${row.company_code}-${row.month}`} onClick={() => onSelectMonth(month)} style={selected ? selectedRow : clickableRow}>
                  <Td last={last} strong={selected}>{month}</Td>
                  <Td last={last} right>{fmt(row.reservation_count)}</Td>
                  <Td last={last} right>{`${fmt(row.booking_event_count)} / ${fmt(row.change_event_count)} / ${fmt(row.cancel_event_count)}`}</Td>
                  <Td last={last} right>{`${fmt(row.detailed_event_count)} / ${fmt(row.revenue_event_count)}`}</Td>
                  <Td last={last} right danger={num(row.customer_net_change) < 0}>{fmt(row.customer_net_change)}</Td>
                  <Td last={last} right danger={num(row.cost_net_change) < 0}>{fmt(row.cost_net_change)}</Td>
                  <Td last={last} right>{fmt(row.supplier_refund)}</Td>
                  <Td last={last} right>{fmt(row.supplier_cancel_fee)}</Td>
                  <Td last={last} right>{fmt(row.additional_cost)}</Td>
                  <Td last={last} right danger={num(row.misc) < 0}>{fmt(row.misc)}</Td>
                  <Td last={last} right strong danger={num(row.net_profit) < 0}>{fmt(row.net_profit)}</Td>
                  <Td last={last} right strong danger={num(cumulative.get(`${row.company_code}-${row.month}`)) < 0}>{fmt(cumulative.get(`${row.company_code}-${row.month}`))}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function Th({ children, right }) {
  return <th style={{ ...thStyle, textAlign: right ? 'right' : 'left' }}>{children}</th>;
}

function Td({ children, right, strong, danger, last }) {
  return (
    <td style={{
      ...tdStyle,
      ...(last ? { borderBottom: 'none' } : null),
      textAlign: right ? 'right' : 'left',
      fontWeight: strong ? 850 : 500,
      color: danger ? '#dc2626' : 'var(--text)',
    }}>
      {children}
    </td>
  );
}

// 디자인 표준: 섹션은 박스 없이(제목 행 + 표 카드), 표는 stdTableWrap + 검정 머리글 띠
const cardStyle = { display: 'grid', gap: 8 };
const sectionHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 };
const sectionTitle = { margin: 0, fontSize: 14, color: 'var(--text)' };
const smallBtn = { ...stdOutlineBtn, padding: '5px 12px' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', minWidth: 1180, fontSize: 12 };
const thStyle = { ...stdTh, padding: '7px 8px' };
const tdStyle = { padding: '7px 8px', borderBottom: '1px solid var(--bg-subtle)', verticalAlign: 'middle', whiteSpace: 'nowrap' };
const emptyTd = { padding: 18, textAlign: 'center', color: 'var(--text-muted)', borderBottom: 'none' };
const clickableRow = { cursor: 'pointer' };
const selectedRow = { cursor: 'pointer', background: 'var(--std-badge-bg, rgba(59, 154, 242, 0.10))' };
